// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {Link, useLocation} from 'react-router-dom';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

type Props = {
  points?: number,
  error?: string,
};

const useStyles = makeStyles(theme => ({
  containerRedeem: {
    width: '100%',
    background: '#7B39FF',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    padding: theme.spacing(1),
    marginBottom: '1rem',
    '& .MuiButton-disableElevation.Mui-disabled': {
      opacity: '0.4',
    },
  },
  earnedPointText: {
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 500,
    color: '#FFFFFF',
  },
  containerEarnings: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  earnedPoints: {
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '0.02em',
    color: '#FFFFFF',
  },
  redeem: {
    backgroundColor: '#FBBF34',
    borderRadius: '20px',
    color: '#500BDB',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    '&:hover': {
      backgroundColor: '#FBBF34!important',
    },
    '&:disabled': {
      opacity: '0.4',
      backgroundColor: '#7B39FF!important',
    },
  },
}));

export default function RedeemPoints(props: Props) {
  const {points, error} = props;

  const {pathname} = useLocation();
  const classes = useStyles();

  return (
    <div className={classes.containerRedeem}>
      <div className={classes.containerEarnings}>
        <Typography className={classes.earnedPointText}>
          Puntos ganados
        </Typography>
        <Typography className={classes.earnedPoints} id="referrals-points">
          {points ? points : 0}
        </Typography>
      </div>
      <CustomButton
        variant="outlined"
        disabled={error}
        className={classes.redeem}
        component={Link}
        to={
          pathname.startsWith('/profile/referral/redeem')
            ? '/profile/referral'
            : '/profile/referral/redeem'
        }
      >
        {pathname.startsWith('/profile/referral/redeem')
          ? 'Referir amigos'
          : 'Canjear'}
      </CustomButton>
    </div>
  );
}

RedeemPoints.propTypes = {
  points: PropTypes.number,
  error: PropTypes.string,
};
